export const PaymentStatusEnum = {
    NEW: 0,
    PENDING: 1,
    COMPLETED: 2,
    CANCELLED: 3,
};
